import { render, staticRenderFns } from "./app-header-message.vue?vue&type=template&id=48de5f7e"
import script from "./app-header-message.vue?vue&type=script&lang=js"
export * from "./app-header-message.vue?vue&type=script&lang=js"
import style0 from "./app-header-message.vue?vue&type=style&index=0&id=48de5f7e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports